/* eslint-disable jsx-a11y/anchor-has-content,no-nested-ternary */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import moment from 'moment';
import {filterUrl, filterYitmMobileContent, isInternalLink} from "../../helpers/filters";
import IconArrowSVG from '../../../public/images/global/icon__arrow.svg';

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentFeaturedArticl {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldDate {
            value
            date
          }
          fieldExcerptIntro
          fieldMoreInfoLink {
            ... on FieldParagraphFieldMoreInfoLink {
              url {
                path
                routed
              }
              title
            }
          }
          fieldObjectImgMedia {
            ... on FieldParagraphFieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentFeaturedArticle extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;
                    const linkIsInternal = field.fieldMoreInfoLink && field.fieldMoreInfoLink.url && field.fieldMoreInfoLink.url.path ? isInternalLink(field.fieldMoreInfoLink.url.path) : null;

                    markComponentLoadedAs(id, true);

                    return (

                        <section className="yitm__articleFeat">
                            <header>
                                <div className="container">
                                    {field.fieldTxtSubTitle ? (<h2>{field.fieldTxtSubTitle}</h2>) : null}
                                    {field.fieldDate  && field.fieldDate.value ? (<span>{moment(field.fieldDate.value).format('MMMM D, YYYY')}</span>) : null}
                                </div>
                            </header>

                            <article className="yitm__articleFeatEntry">
                                <div className="container">
                                    {field.fieldTxtHeadline ? (<h2>{field.fieldTxtHeadline}</h2>) : null}
                                    {field.fieldExcerptIntro ? (<p dangerouslySetInnerHTML={{__html: filterYitmMobileContent(field.fieldExcerptIntro)}}/>) : null}

                                    {field.fieldMoreInfoLink && field.fieldMoreInfoLink.url && (
                                        <a className="yitm__articleFeatMore"
                                           target={linkIsInternal ? '_self' : '_blank'}
                                           rel={linkIsInternal ? null : 'noopener noreferrer'}
                                           href={filterUrl(field.fieldMoreInfoLink.url.path)}>
                                            {field.fieldMoreInfoLink.title} <IconArrowSVG/>
                                        </a>
                                    )}

                                </div>
                            </article>

                            {field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url ?
                                field.fieldMoreInfoLink && field.fieldMoreInfoLink.url ? (
                                    <a className="yitm__articleFeatImageAnchor"
                                       target={linkIsInternal ? '_self' : '_blank'}
                                       rel={linkIsInternal ? null : 'noopener noreferrer'}
                                       href={filterUrl(field.fieldMoreInfoLink.url.path)}>
                                        <img className="yitm__articleFeatImage"
                                             src={field.fieldObjectImgMedia.entity.fieldMediaImage.url}
                                             alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                    </a>
                                ) : (
                                    <img className="yitm__articleFeatImage"
                                         src={field.fieldObjectImgMedia.entity.fieldMediaImage.url}
                                         alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                )

                            : null}

                        </section>

                );
                }}
            </Query>
        )
    }

}


export default MobileComponentFeaturedArticle;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentFeaturedArticle.jsx